import { VatikaUserList } from '../../constants/constants';

export const OPERATOR_ROLES = {
  operatorGroup: 'Operator Group',
  rotatingOperator: 'Rotating Operator',
} as const;

export const PROFILE_MENU_ITEM_IDS = [
  'profile',
  'notifications',
  'logout',
  'stopViewAs',
  'viewAs',
  'checkin',
  'checkout',
  'attendance',
  'about',
] as const;

export type ProfileMenuItemId = (typeof PROFILE_MENU_ITEM_IDS)[number];

export interface ProfileMenuAccess {
  role: string;
  isStaff: boolean;
  isViewing: boolean;
  allowAction: boolean;
}

const isOperatorGroup = ({ role }: ProfileMenuAccess): boolean => role === OPERATOR_ROLES.operatorGroup;

const ITEM_RULES: Record<ProfileMenuItemId, (access: ProfileMenuAccess) => boolean> = {
  profile: () => true,
  notifications: () => true,
  logout: () => true,
  stopViewAs: ({ isViewing }) => isViewing,
  viewAs: ({ isStaff, isViewing }) => isStaff && !isViewing,
  checkin: isOperatorGroup,
  checkout: (access) => access.allowAction && isOperatorGroup(access),
  attendance: ({ role }) => role === OPERATOR_ROLES.rotatingOperator,
  about: () => true,
};

export const visibleProfileMenuItems = (access: ProfileMenuAccess): readonly ProfileMenuItemId[] =>
  PROFILE_MENU_ITEM_IDS.filter((id) => ITEM_RULES[id](access));

export const isVatikaUser = (email: string): boolean => VatikaUserList.includes(email);
